'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

// ----------------------------------------
// Private
// ----------------------------------------

let $hidden = $('.hide');
let $checkbox = $('.shop-check');
let $td = $('.shop__table-select');
let $text = $('.shop__table-text');

// ----------------------------------------
// Public
// ----------------------------------------

function toggleContent () {
	$checkbox.change(function () {
		let $show = $(this).closest('tr').find($hidden);
		let $open = $(this).closest('tr').find($td);
		let $hide = $(this).closest('tr').find($text);

		if (this.checked) {
			$hide.toggle();
			$show.slideDown('slow');
			$open
				.attr('colspan', 1)
				.toggleClass('close');
		} else {
			$show.toggle();
			$hide.toggle();

			$open
				.attr('colspan', 4)
				.toggleClass('close');
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {toggleContent};



// WEBPACK FOOTER //
// ./src/js/_modules/tables.js